import { render } from "./DateSlider.vue?vue&type=template&id=f8540178&scoped=true"
import script from "./DateSlider.vue?vue&type=script&lang=js"
export * from "./DateSlider.vue?vue&type=script&lang=js"

import "./DateSlider.vue?vue&type=style&index=0&id=f8540178&scoped=true&lang=css"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8540178"]])

export default __exports__